module.exports = __webpack_public_path__ + "img/home-personas-1.3c05c7f.webp";